import Params from '@/modules/Product/components/Main/components/Tabs/components/Collapse/components/Params';
import Description from '@/modules/Product/components/Main/components/Tabs/components/Collapse/components/Description';
import Schema from '@/modules/Product/components/Main/components/Tabs/components/Collapse/components/Schema';

export const getChildNode = (type: string) => {
  return type === 'params'
    ? Params
    : type === 'description'
    ? Description
    : type === 'schema'
    ? Schema
    : null;
};
